<template>
  <prod-page>
    <el-row style="width: 64%;margin-left: 18%;margin-top: 40px;display: flex;">
      <el-col style="width: 26%;border-right: 1px solid #5e5e5e;">
        <el-row v-for="(data, i) in dataList" :key="i" :class="i === selMenu ? 'menu-class-hover' : 'menu-class'" @click.native="clickMenu(i)">
          {{data.name}}
        </el-row>
      </el-col>
      <el-col v-if="data !== ''" style="width: 67%;margin-left: 7%;text-align: left;">
        <el-row class="title-class">{{data.name}}</el-row>
        <el-row class="sub-title-class">方案介绍</el-row>
        <el-row class="text-class">{{data.introduce}}</el-row>
        <el-row v-if="data.situation !== ''" class="sub-title-class">应用场景</el-row>
        <el-row v-if="data.situation !== ''" style="display: flex;">
          <div v-for="(item, i) in data.situation" :key="i" :style="{'height': data.situationHeight, 'width': 'calc(100%/' + data.situation.length + '-' + (data.situation.length + 1) * 10 + 'px)', 'margin-left': '10px'}">
            <el-image :src="item.image" fit="scale-down"></el-image>
            <div style="text-align: center;margin-top: 10px;">{{item.name}}</div>
          </div>
        </el-row>
        <el-row v-if="data.functionImage !== ''" class="sub-title-class">平台功能</el-row>
        <el-row v-if="data.functionImage !== ''" style="display: flex;flex-wrap: wrap;">
          <div v-for="(item, i) in data.functionImage" :key="i" :style="{'height': data.functionHeight, 'width': 'calc(50% - 45px)', 'margin-left': '30px'}">
            <el-image :src="item.image" fit="scale-down"></el-image>
            <div style="text-align: center;margin-top: 10px;">{{item.name}}</div>
          </div>
        </el-row>
        <el-row v-if="data.function !== ''" class="sub-title-class">平台功能</el-row>
        <el-row v-if="data.function !== ''" class="text-class">{{data.function}}</el-row>
        <el-row class="sub-title-class">系统架构</el-row>
        <el-image :src="data.struct" class="img-class" :style="{'height': data.structHeight}" fit="scale-down"></el-image>
        <el-row v-if="data.worth !== ''" class="sub-title-class">客户价值</el-row>
        <el-row v-if="data.worth !== ''" class="text-class">{{data.worth}}</el-row>
        <el-row v-if="data.worthImage !== ''" class="sub-title-class">客户价值</el-row>
        <el-image v-if="data.worthImage !== ''" :src="data.worthImage" class="img-class" :style="{'height': data.worthHeight}" fit="scale-down"></el-image>
        <el-row v-if="data.fileInfo" class="sub-title-class">产品介绍</el-row>
        <el-link v-if="data.fileInfo" :underline="false" style="color: #00bf86;font-size: 16px;" :href="'/software/downloadFile?id=' + data.fileInfo.id + '&name=' + data.fileInfo.name" target="_blank">{{data.fileInfo.name}}</el-link>
      </el-col>
    </el-row>
  </prod-page>
</template>

<script>
import ProdPage from './ProdPage'
export default {
  name: 'software',
  components: {ProdPage},
  props: {
    'selId': {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dataList: [
        {
          id: '311',
          param: 'ems',
          name: '综合能源管理系统',
          introduce: '       瑜岿综合能源管理系统采用B/S + 微服务总体架构，运用成熟的物联网技术，实现对企业/建筑电、水、气、热等能源数据采集，并通过图形、图表等形式直观展示数据实时状态及呈现趋势，通过节能分析专家系统，提取能源数据中的有用信息，最终完成从能源数据向节能知识的转化，为客户从能源数据中挖掘节能机会点。',
          situation: [
            {name: '工业园区', image: require('../../assets/img/product/situation_0.jpg')},
            {name: '医院', image: require('../../assets/img/product/situation_1.jpg')},
            {name: '高能耗企业', image: require('../../assets/img/product/situation_2.jpg')}
          ],
          situationHeight: '220px',
          functionImage: [
            {name: '能源监测', image: require('../../assets/img/product/function_0.png')},
            {name: '节能分析', image: require('../../assets/img/product/function_1.png')},
            {name: '报表管理', image: require('../../assets/img/product/function_2.png')},
            {name: '用户报告', image: require('../../assets/img/product/function_3.png')}
          ],
          functionHeight: '320px',
          function: '',
          struct: require('../../assets/img/product/struct1.jpg'),
          structHeight: '360px',
          worthImage: require('../../assets/img/product/worth_0.jpg'),
          worthHeight: '310px',
          worth: '',
          fileInfo: {id: '2e30c27f63654e4293108681dd776822', name: 'EMS-产品介绍.pdf'}
        },
        {
          id: '312',
          param: 'soms',
          name: '分布式光伏运维系统',
          introduce: '       集发电数据采集、统计分析、智能工单管理、告警于一体的集中式光伏运维管理系统。系统通过对光伏电站内逆变器、汇流箱、并网点、环境探测设备等集中采集与分析，以直观的数据和丰富的图表形式向管理人员展示光伏电站的运营情况，并通过智能化的移动工单系统提升电站运维的准确性及时效性，从多个维度保障光伏电站的高效运行。',
          situation: '',
          functionImage: '',
          function: '',
          struct: require('../../assets/img/product/struct2.png'),
          structHeight: '600px',
          worthImage: '',
          worth: '       远程监视，保障电站稳定运行：明晰分布式光伏电站的发电及收益情况，帮助企业建立激励机制，持续降本增效；及时发现故障发电单元，缩短故障时长，提高运行效率；结合视频监控云平台，随时调取视频录像，保障电站安全运行。\n' +
            '       智能运维，保障电站高效运行：完备的智能移动工单系统，保障企业运维工作的业务闭环和高效运作；可视化的工单管理，帮助企业随时掌握工单进展情况；标准化的运维模板和专家系统，降低运维人员的工作难度。\n' +
            '       智能分析，保障电站经济效益：充分运用大数据及人工智能技术，帮助企业充分挖掘降本增效潜力；运用横、纵向对标等方式，智能排查低效组件，保障电站高效运行及企业利益最大化。'
        },
        {
          id: '313',
          param: 'doms',
          name: '智慧配电系统',
          introduce: '       针对传统配电房设备老旧、巡检效率低下、日常维护落实难、安全隐患发现不及时等问题，我们为客户提供一整套智能配电房解决方案，从实时监控、异常告警、工单管理、风险评估、专家智库等多个方面，满足用户对配电房数字化、自动化、智能化的诉求。',
          situation: '',
          functionImage: '',
          function: '',
          struct: require('../../assets/img/product/struct3.png'),
          structHeight: '430px',
          worthImage: '',
          worth: '全方位实时监控：通过视频监控系统、门禁系统、环境探测系统（环境温湿度探测、水浸探测等）、电力监控系统，实时监测配电房的运行及环境数据，对人员非法闯入、火险、水浸、短路、线温过高、故障电弧等异常情况及时告警，保障配电房安全运营。\n' +
            '提升运维效率：通过提供完善的移动工单系统，保障配电房数字化运维的高效运作；通过专家智库向维修人员主动推送故障处理预案，提升故障消缺效率；通过配备巡检机器人，进一步降低配电房事故率。\n' +
            '智能分析：运用大数据、人工智能算法等技术，实现配电房从被动式维护向预测性维护的转型升级，运用先进的模式识别（APR）算法对配电设备进行故障预测与风险评估，定期推送分析报告与处理建议。'
        },
        {
          id: '314',
          param: 'ppms',
          name: '预付费系统',
          introduce: '       预付费管理系统是针对电、水能源供应提供的一套先交费后使用的系统解决方案。支持系统预付费和表计预付费两种计费方式，满足客户集中管理、移动支付、低额提醒、欠费告警、远程控制等需求，在方便管理方的同时，也为用户提供了更加便捷的支付手段，提升管理效率和用户体验。',
          situation: '',
          functionImage: '',
          function: '',
          struct: require('../../assets/img/product/struct4.png'),
          structHeight: '490px',
          worthImage: '',
          worth: '实时监控：管理员可以通过网页客户端查看实时用电情况，支持远程拉合闸控制支路供电。\n' +
            '便捷支付：用户可以通过支付宝或微信等移动支付平台完成预交费。\n' +
            '账单查询：用户可以随时查询费用账单，用电、用水明细一目了然。'
        },
        {
          id: '315',
          param: 'efms',
          name: '电气火灾监测系统',
          introduce: '       基于能源物联网平台，针对用电安全需求较高场所的一套系统解决方案，集剩余电流、导线超温、故障电弧、过流、过载、短路等隐患监测于一体，真正实现7 x 24小时全天候数字化监测，支持邮件、短信等告警方式，以及提供完备的电气火灾风险评估体系，做到"防火与未燃"。',
          situation: '',
          functionImage: '',
          function: '',
          struct: require('../../assets/img/product/struct5.png'),
          structHeight: '470px',
          worthImage: '',
          worth: '实时监控：24小时实时监控被保护线路，立即报警火灾隐患，联动配电运维系统，及时消除火灾隐患，降低火灾风险。\n' +
            '历史查询：提供历史报警数据查询通道，为制定电气火灾防控工作计划提供数据支撑。\n' +
            '隐患预警：运用大数据分析及人工智能算法，构建“电气火灾风险评估体系”，通过“隐患指数”预警火灾风险程度，为预测性维护提供决策依据。'
        }
      ],
      data: '',
      selMenu: 0,
      dict: {'311': 0, '312': 1, '313': 2, '314': 3, '315': 4}
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    if (this.$route.query.page) {
      let sel = this.dict[this.$route.query.page]
      this.selMenu = sel
      this.data = this.dataList[sel]
    } else {
      this.$router.push({query: {page: '311'}})
    }
  },
  watch: {
    $route: {
      handler() {
        let page = this.$route.query.page
        if (page) {
          this.clickMenuExternal(page)
        }
      },
      deep: true
    }
  },
  methods: {
    clickMenu(i) {
      if (this.selMenu !== i) {
        this.$router.push({path: this.$route.path, query: {page: this.dataList[i].id}})
      }
    },
    clickMenuExternal(page) {
      let sel = this.dict[page]
      this.selMenu = sel
      this.data = this.dataList[sel]
    }
  }
}
</script>

<style scoped>
  .menu-class {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #efefef;
    color: #000000;
    cursor: pointer;
  }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .title-class {
    color: #00bf86;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .sub-title-class {
    color: #5e5e5e;
    font-size: 19px;
    font-weight: bold;
    margin-top: 25px;
    margin-bottom: 25px;
  }
  .text-class {
    color: #5e5e5e;
    font-size: 16px;
    margin-bottom: 10px;
    white-space: pre-wrap;
    line-height: 34px;
  }
  .img-class {
    width: 100%;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Software.vue